import SnapsnapGateway from '@/gateways/SnapsnapGateway'
import GroupRepository from '@/repositories/GroupRepository'
import GroupEntity from '@/entities/Group'

export interface IFetchGroupsUseCaseParams {
  snapsnapGateway: SnapsnapGateway
  groupRepository: GroupRepository
}

export default class FetchGroupsUseCase implements BaseUseCase {
  private snapsnapGateway: SnapsnapGateway
  private groupRepository: GroupRepository

  constructor(params: IFetchGroupsUseCaseParams) {
    const { snapsnapGateway, groupRepository } = params

    this.snapsnapGateway = snapsnapGateway

    this.groupRepository = groupRepository
  }

  async execute(): Promise<GroupEntity[]> {
    try {
      const groups = await this.snapsnapGateway.getGroups()
      this.groupRepository.saveGroups(groups)
      return groups.map(group => new GroupEntity(group))
    } catch (error) {
      throw error
    }
  }
}
